import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] text-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-sm bg-[#FDFBF7] text-[#0A192F] font-serif-display text-2xl leading-none">
                ★
              </span>
              <div>
                <div className="font-serif-display text-xl">Lone Star</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#E2DCD0]">
                  Surplus Recovery LLC
                </div>
              </div>
            </div>
            <p className="text-[#E2DCD0] text-sm leading-relaxed max-w-md">
              Helping rightful owners and their heirs recover surplus funds held
              by counties and courts. Texas based — serving claimants across
              the United States.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[#D4AF37] text-xs uppercase tracking-[0.22em] mb-5">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-[#E2DCD0]">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#D4AF37]" />
                <a href="tel:8176802751" data-testid="footer-phone" className="hover:text-[#FDFBF7]">
                  817-680-2751
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#D4AF37]" />
                <a
                  href="mailto:claims@lonestarsurplus.net"
                  data-testid="footer-email"
                  className="hover:text-[#FDFBF7]"
                >
                  claims@lonestarsurplus.net
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#D4AF37] mt-0.5" />
                <span>Texas, USA · Nationwide claims</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[#D4AF37] text-xs uppercase tracking-[0.22em] mb-5">
              Explore
            </div>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-6 text-sm text-[#E2DCD0]">
              <li><a href="#education" className="hover:text-[#FDFBF7]">What is Surplus?</a></li>
              <li><a href="#process" className="hover:text-[#FDFBF7]">How It Works</a></li>
              <li><a href="#why-us" className="hover:text-[#FDFBF7]">Why Choose Us</a></li>
              <li><a href="#about" className="hover:text-[#FDFBF7]">About Silas</a></li>
              <li><a href="#faq" className="hover:text-[#FDFBF7]">FAQ</a></li>
              <li><a href="#claim" className="hover:text-[#FDFBF7]">Claim Check</a></li>
            </ul>
          </div>
        </div>

        <div className="hairline mb-8 opacity-30" />

        <div className="flex flex-col md:flex-row md:justify-between gap-4 text-xs text-[#E2DCD0]/70">
          <p>© {new Date().getFullYear()} Lone Star Surplus Recovery LLC. All rights reserved.</p>
          <p className="max-w-2xl md:text-right">
            Lone Star Surplus Recovery LLC is not a law firm and does not
            provide legal advice. Recovery outcomes vary and depend on case
            facts and jurisdiction.
          </p>
        </div>
      </div>
    </footer>
  );
};
